/**
 * Debounce function that return debounced callback
 * @param func any function that should be debounced
 * @param debounceTime delay in ms
 */
export const debounce = (func: (args: unknown) => void, debounceTime: number = 300) => {
	let timer: ReturnType<typeof setTimeout> | null = null;
	return (...args: unknown[]) => {
		if (timer) {
			clearTimeout(timer);
		}
		timer = setTimeout(() => {
			timer = null;
			func(...([args] as const));
		}, debounceTime);
	};
};
